import { useTranslation } from "react-i18next";

/*
 * TimeseriesPreviewModal 역할:
 * - 선택한 리포트 이미지를 원본 크기에 가깝게 미리보기 모달로 보여준다.
 * - 배경 클릭과 닫기 버튼을 같은 닫기 핸들러로 연결한다.
 */
export default function TimeseriesPreviewModal({ previewImage, onClose }) {
  const { t } = useTranslation();

  if (!previewImage) return null;

  return (
    <>
      <div
        className="equipmentTimeseriesReport previewOverlay"
        onClick={onClose}
      />
      <div
        className="equipmentTimeseriesReport previewModal"
        role="dialog"
        aria-modal="true"
        aria-label={
          previewImage.title ||
          t("imageFileIndex.timeseries.preview.originalImageView", {
            defaultValue: "원본 이미지 보기",
          })
        }
      >
        <button
          type="button"
          className="equipmentTimeseriesReport previewCloseButton"
          onClick={onClose}
          aria-label={t("imageFileIndex.timeseries.preview.close", {
            defaultValue: "닫기",
          })}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {previewImage.title ? (
          <p className="equipmentTimeseriesReport previewTitle">
            {previewImage.title}
          </p>
        ) : null}
        <div className="equipmentTimeseriesReport previewViewport">
          <img
            className="equipmentTimeseriesReport previewImage"
            src={previewImage.src}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
